import { Accordion, IAccordionItem, Icon } from 'kl-b2c-ui-kit';
import React, { FC } from 'react';
import { DefaultTheme, withTheme } from 'styled-components';

export type AccordionVariant = 'light' | 'dark';

interface PrimaryAccordionProps {
    items: IAccordionItem[];
    theme: DefaultTheme;
    variant?: AccordionVariant;
    headerFontSize?: number;
}

const PrimaryAccordion: FC<PrimaryAccordionProps> = ({ items, theme, variant = 'light', headerFontSize = 18 }) => {
    const isDark = variant === 'dark';

    const lightConfig = {
        ItemConfig: {
            css: {
                borderRadius: 8,
                background: `${theme.palette.green}1A`,
                padding: '0px 24px',
                border: `1px solid ${theme.palette.green}`,
                position: 'relative',
                zIndex: 25,
                backdropFilter: 'blur(92px)',
                '@media screen and (max-width: 767px)': {
                    backdropFilter: 'blur(24px)',
                },
            },
        },
        HeaderConfig: {
            css: {
                padding: '20px 0px',
                fontSize: `${headerFontSize}px`,
                lineHeight: '21px',
                fontWeight: 600,
            },
        },
        BodyConfig: {
            css: {
                padding: '0px 0px 0px 0px',
            },
        },
    };

    const darkConfig = {
        ItemConfig: {
            css: {
                borderRadius: 16,
                background: theme.palette.white,
                border: `1px solid ${theme.palette.gray[600]}`,
                position: 'relative',
                zIndex: 25,
                overflow: 'hidden',
                transition: 'all 0.3s ease',
            },
        },
        ActiveItemConfig: {
            css: {
                background: theme.palette.background,
                border: `1px solid ${theme.palette.background}`,
                color: theme.palette.white,
            },
        },
        HeaderConfig: {
            css: {
                padding: '36px 24px',
                fontSize: '22px',
                lineHeight: '22px',
                fontWeight: 500,
                color: theme.palette.black,
                transition: 'all 0.3s ease',
                '& path, & svg': {
                    stroke: theme.palette.black,
                    fill: theme.palette.black,
                },
                '& svg': {
                    transform: 'rotate(45deg)',
                    transition: 'transform 0.3s ease',
                },
            },
        },
        ActiveHeaderConfig: {
            css: {
                color: theme.palette.white,
                '& path, & svg': {
                    stroke: theme.palette.white,
                    fill: theme.palette.white,
                },
                '& svg': {
                    transform: 'rotate(-45deg)',
                    transition: 'transform 0.3s ease',
                },
            },
        },
        BodyConfig: {
            css: {
                padding: '0px 16px 24px 16px',
            },
        },
    };

    return (
        <Accordion
            atSelector={'directionsModalTabMenuBodyTeamsAccordionContainer'}
            distanceBetweenItems={isDark ? 15 : 20}
            iconClose={
                isDark ? (
                    <Icon name={'ArrowRightThin'} size={18} />
                ) : (
                    <Icon name={'ShowLess'} size={18} color={'primary'} />
                )
            }
            iconOpen={
                isDark ? (
                    <Icon name={'ArrowRightThin'} size={18} />
                ) : (
                    <Icon name={'ShowMore'} size={18} color={'primary'} />
                )
            }
            config={isDark ? darkConfig : lightConfig}
            items={items}
        />
    );
};

export default withTheme(PrimaryAccordion);
